import React from "react";

import { styled, useMediaQuery, useTheme } from "@mui/material";
import AccordonCommon from "../../CommonScreens/AccordonCommon";
import { Drawer } from "@mui/material";

const RightTabWrapper = styled("div")(({ theme }) => {
  return {
    ".web_tooltiop_member_container": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: " flex-end",
      position: "absolute",
      width: "100%",
      // height: "70vh",
      overflowY: "scroll",
      top:'65px',
      "-ms-overflow-style": "none",
      "::-webkit-scrollbar": {
        display: "none",
      },
    },
    ".web_tag_main_div": {
      // position: "fixed",
      zIndex: 1,
    },
    ".web_tag": {
      boxShadow:
        "rgb(50 50 93 / 25%) 0px 0px 0px 0px inset, rgb(0 0 0 / 30%) 0px 22px 26px -15px inset",
      backgroundColor: "#5f52a1",
      height: "10vw",
      width: "4vw",
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "center",
      padding: "1.5vw 0",
      cursor: "pointer",
    },
    ".web_patch_icon": {
      objectFit: "contain",
      width: "1.76vw",
      marginBottom: "1em",
    },
    ".web_patch_text": {
      marginTop: "0.6vw",
      width: "11vw",
      height: "2vw",
      transform: "rotate(-90deg)",
      fontSize: "1.3vw",
      fontWeight: 500,
      color: "#ffffff",
    },
    // Responsive
    [theme.breakpoints.down(1024)]: {
      ".web_tooltiop_member_container": {
        display: "none",
      },
    },
  };
});


export const RightTabs = (props) => {
  const { ...rest } = props;
  const theme = useTheme();
  const [Height, setHeight] = React.useState(0);
  const ref = React.useRef(null);
  const [open, setOpen] = React.useState(false);
  const div_ref = React.useRef(null);

  React.useEffect(() => {
    
  }, []);
  React.useLayoutEffect(() => {
    setHeight(ref?.current?.offsetTop);
  }, []);

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setOpen(open)
   
  };

  return (
    <div ref={ref}>
      <RightTabWrapper  {...rest}>
        <div className="web_tooltiop_member_container">
          <div className="web_tag_main_div">
           
                <div
                  className={"web_tag"}
                  onClick={toggleDrawer(true)}
                >
                  {/* <img src={require('./../../../Assets/Images/my_health.svg')} className="web_patch_icon" /> */}
                  <div className="web_patch_text">
                    RESOURCES
                  </div>
                </div>
              
          </div>
        </div>
      </RightTabWrapper>
      
        <Drawer
        anchor={"right"}
        open={open}
        style={{zIndex: 100,
          marginTop:Height}}
        onClose={toggleDrawer(false)}
      >
        <div style={{padding:30}}>
        <AccordonCommon
          clientId={props.data.clientId}
          clientName={props.data.clientName}
          agentId={props.data.agentId}
          disable={true}
        />
        </div>
       
      </Drawer>
      

    </div>
  );
};
